import { render, staticRenderFns } from "./asignDeliveryDriver.vue?vue&type=template&id=fee2d068&scoped=true&"
import script from "./asignDeliveryDriver.vue?vue&type=script&lang=js&"
export * from "./asignDeliveryDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee2d068",
  null
  
)

export default component.exports